$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');

  // Mobile Buttons
  $('.mobile-menu-ticket-btn').wrap('<div class="mobile-wrap"></div>');

  // Duplicate and append Donate and Tickets Buttons
  $(".ticket").clone().insertBefore(".headerInnerContent .header-top .inner .searchBox").addClass("ticket-scroll");
  $(".donate").clone().insertBefore(".headerInnerContent .header-top .inner .searchBox").addClass("donate-scroll");
  $(".donate-scroll").clone().appendTo(".mobile-wrap");

  var topHeader = $('.header-top .right');
  var navPadding = $('.showingNav');

  $('.hamburger').on('click', function() {
    topHeader.addClass('nav-open');
  });
  
  $('.scroll-close').on('click', function() {
    topHeader.removeClass('nav-open');
  });
  
  $(window).on('scroll', function() {
    if ( !$('body').hasClass('saffireWindowScrolled') ) {
      topHeader.removeClass('nav-open');
    }

    if ( !$('body').hasClass('saffireWindowScrolled') ) {
      navPadding.css("padding", "10px 8px 10px 8px");
    }

  });
  
  $(window).on('resize', function() {
    if ( window.innerWidth <= 1110 ) {
      topHeader.removeClass('nav-open');
    }
  });
});

$(window).load(function () {
  // ---

});